import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "@mui/material/Card";
import { CircularProgress } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import ComplexReportsDoughnutChart from "examples/DoughnutCharts/ComplexReportsDoughnutChart";
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../../constants";
import { getDomainIdSync } from "../../../../utils/utils";
import { useSystemTheme } from "context/SystemThemeContext";

function Social({ dateRange }) {
  const { mode } = useSystemTheme();
  const isDarkMode = mode === "dark";
  
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: {
      label: "User Count",
      data: [],
      backgroundColors: [],
    },
  });
  const [loading, setLoading] = useState(true);

  const GetLast30Days = () => {
    const end_date = new Date();
    const start_date = new Date();
    start_date.setDate(end_date.getDate() - 29);
    const formatDate = (date) => date.toISOString().split("T")[0];
    return {
      start_date: formatDate(start_date),
      end_date: formatDate(end_date),
    };
  };

  useEffect(() => {
    const domainId = getDomainIdSync();
    const { start_date, end_date } =
      dateRange.start_date && dateRange.end_date
        ? dateRange
        : GetLast30Days();

    setLoading(true);

    axios
      .get(`${LAMBDA_BASE_URL}/users-count-by-country`, {
        headers: { "DOMAIN-TOKEN": domainId },
        params: { start_date, end_date },
      })
      .then((response) => {
        const rawResult = response.data.result || [];

        const grouped = rawResult.reduce((acc, curr) => {
          const country = curr.country || "Other";
          const count = curr.count || curr.user_count || 0;
          acc[country] = (acc[country] || 0) + count;
          return acc;
        }, {});

        const sorted = Object.entries(grouped)
          .sort((a, b) => b[1] - a[1])
          .filter(([_, count]) => count > 0);

        let labels = [];
        let data = [];

        if (sorted.length > 5) {
          const top5 = sorted.slice(0, 5);
          const others = sorted.slice(5);
          const otherCount = others.reduce((sum, [_, count]) => sum + count, 0);
          labels = [...top5.map(([country]) => country), "Other"];
          data = [...top5.map(([_, count]) => count), otherCount];
        } else {
          labels = sorted.map(([country]) => country);
          data = sorted.map(([_, count]) => count);
        }

        const colorPalette = [
          "teal",
          "info",
          "primary",
          "secondary",
          "dark",
          "success",
          "warning",
          "error",
          "facebook",
          "twitter",
          "instagram",
          "linkedin",
          "pinterest",
          "youtube",
        ];
        const backgroundColors = labels.map(
          (_, i) => colorPalette[i % colorPalette.length]
        );
        setChartData({
          labels,
          datasets: {
            label: "User Count",
            data,
            backgroundColors,
          },
        });
      })
      .catch((err) => {
        console.error("Error fetching user count by country:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dateRange]);

  const totalUsers =
    chartData.datasets?.data?.reduce((sum, val) => sum + val, 0) || 0;

  return (
    <Card sx={{ 
      height: "375px", 
      display: "flex", 
      flexDirection: "column",
      backgroundColor: isDarkMode ? "#060C18" : "#ffffff",
      transition: "background-color 0.3s ease",
      border: isDarkMode ? "1px solid #2d2d3f" : "none",
    }}>
      <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
        {/* <SoftTypography variant="h6">Queries by Country</SoftTypography> */}
      </SoftBox>

      <SoftBox sx={{ height: "100%", overflowY: "auto" }}>
        {loading ? (
          <SoftTypography 
            variant="body2" 
            sx={{ 
              color: isDarkMode ? "#e2e8f0" : "text",
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              mt: 10 
            }}
          >
            <CircularProgress sx={{ color: "#219297" }} />
          </SoftTypography>
        ) : (
          <ComplexReportsDoughnutChart
            title="Visitors by Country"
            count={{ number: totalUsers, text: "Queries" }}
            chart={chartData}
            tooltip="Top 5 countries and others grouped"
          />
        )}
      </SoftBox>
    </Card>
  );
}

export default Social;